
export const footerContent = {
  en: {
    header: `Providing accessible, professional physiotherapy care online.
              Your movement, our priority.`,

    title1: "Services",
    videoConsultation: "Video Consultations",
    injuryRehabilitation: "Injury Rehabilitation",
    painManegment: "Pain Manegment",
    store: "Store",
    sportsTherapy: "Sports Therapy and Fitness",
    platform: "Platform",

    title2: "Company",
    aboutUs: "About Us",
    ourTeam: "Our Team",
    careers: "Careers",
    blog: "Blog",
    home: "Home",
    forPhysios: "For Physios",

    title3: "Support",
    faqs: "FAQs",
    helpCenter: "Help Center",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",

    header2: "Ready to Start Your Recovery?",
    text2: `Join hundreds of patients already improving their physical health with
            Revimo.`,
    buttonConsultation: "Create Account",

    allRightsReserved: "© 2026 Revimo. All rights reserved.",
    privacy: "Privacy",
    terms: "Terms",
    cookies: "Cookies",
    accessibility: "Accessibility",
  },
  sl: {
    header: `Spletna fizioterapija, ki je dostopna in strokovna.
              Vaše zdravje, naša prednostna naloga.`,

    title1: "Storitve",
    videoConsultation: "Video posveti",
    injuryRehabilitation: "Rehabilitacija po poškodbah",
    painManegment: "Obravnava bolečine",
    store: "Trgovina",
    sportsTherapy: "Športna fizioterapija in fitnes",
    platform: "Platforma",

    title2: "Podjetje",
    aboutUs: "O nas",
    ourTeam: "Naša ekipa",
    careers: "Zaposlitev",
    blog: "Blog",
    home: "Domov",
    forPhysios: "Za fizioterapevte",

    title3: "Podpora",
    faqs: "Pogosta vprašanja",
    helpCenter: "Center za pomoč",
    contactUs: "Kontakt",
    privacyPolicy: "Pravilnik o zasebnosti",
    termsOfService: "Pogoji uporabe",

    header2: "Pripravljeni na začetek okrevanja?",
    text2: `Pridružite se številnim pacientom, ki z Revimo že izboljšujejo
            svoje zdravje.`,
    buttonConsultation: "Ustvari račun",

    allRightsReserved: "© 2026 Revimo. Vse pravice pridržane.",
    privacy: "Zasebnost",
    terms: "Pogoji",
    cookies: "Piškotki",
    accessibility: "Dostopnost",
  },
} as const;
